
import React from 'react';
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout';
import strings from "../../components/Language";
import axios from 'axios';
import { getToken, storeUserData } from './../../components/Util';
import _ from 'lodash';
import { api } from './../../components/config/api.js';
import Bitcoin from './../../assets/images/icons/bitcoin.svg';
import LoaderContext from '../../components/Loader/LoaderContext.js';
import '../../components/BotCard/botcard.scss';
class ChartScreen extends React.Component {

	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			botLiveData: [],
			data: [],
			is_load: true,
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			setTimeout(() => {
				this.setState({ access_token: token });
				this.getData();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		var self = this;
		if (self.state.access_token) {
			setLoading(true);

			axios({
				method: 'GET',
				url: api.bot_report,
				headers: {
					'Authorization': 'Bearer ' + self.state.access_token,
					'Content-Type': 'application/json',
					'Accept-Language': strings.getLanguage(),
				}
			}).then(function (ress) {
				if (ress.data && ress.data.error === 200) {
					var parinames = "";
					var parinamesArray = [];
					var botData = _.filter(ress.data.data, function (o, key) {
						o.average_ = (o.total_usdt_qty > 0) ? (o.total_usdt_qty / o.total_coin_qty) : 0;
						o.is_calculate = (o.total_coin_qty > 0) ? true : false;

						if (o.pair.name && parinamesArray.indexOf(o.pair.name) == -1) {
							if (parinames) {
								parinames += `,`;
							}
							parinames += `"` + o.pair.name + `"`;
							parinamesArray.push(o.pair.name);
						}

						return o;
					});
					self.setState({ data: botData, pariNames: parinames });

					if (parinames && parinames.length != 0) {
						self.getLiveData();
						setInterval(() => {
							self.getLiveData();
						}, 10000);
					} else {
						setLoading(false);
					}
				} else {
					setLoading(false);
				}
			}).catch(function (e) {
				setLoading(false);
			});
		}
	};

	getLiveData() {
		const { setLoading } = this.context;
		var self = this;
		if (self.state.access_token) {

			axios({
				method: 'GET',
				url: api.marketData,
				headers: {
					'Accept-Language': strings.getLanguage(),
				}
			}).then(function (ress) {
				if (ress && ress.status == 200) {
					var data = _.filter(self.state.data, function (o) {
						var finalLiveData = _.find(ress.data, { symbol: o.pair.name });
						if (finalLiveData) {
							o.liveData = finalLiveData;
						}
						return o;
					})
					self.setState({ get_live_bot: true });
				}
				self.setState({ is_load: false });
				setTimeout(() => {
					setLoading(false);
				});
			}).catch(function (e) {
				setLoading(false);
			});
		}
	};

	render() {
		return (
			<Layout data={{ "title": strings.Chart }}>
				<>
					{!this.state.is_load ?
						<>
							{
								this.state.data.map((item, i) => {
									const live = item.liveData || {};
									const change = Number.parseFloat(live.priceChangePercent);
									const hasChange = Number.isFinite(change);
									const price = Number.parseFloat(live.lastPrice);
									return (
										<Link key={i + 1001} to={{ pathname: `/ChartDetails/${item.pair.name}` }} className="bot-card">
											<div className="bot-card-top">
												<img className="bot-card-avatar" src={(item.pair && item.pair.icon_url) ? item.pair.icon_url : Bitcoin} alt="" width={40} height={40} />
												<div className="bot-card-id">
													<div className="bot-card-name">{(item.pair && item.pair.name) ? item.pair.name : ''}</div>
													<div className="bot-card-meta">{strings.latest_price} · {Number.isFinite(price) ? price.toFixed(5) : '0.00'}</div>
												</div>
												<span className={'bot-card-pill ' + (hasChange && change < 0 ? 'down' : 'up')}>
													{(hasChange && change > 0 ? '+' : '') + (hasChange ? change.toFixed(2) : '0.00')}%
												</span>
											</div>
										</Link>
									);
								})
							}
						</>
						: null
					}
				</>
			</Layout>
		);
	}
}
export default ChartScreen;
